import * as classNames from 'classnames/bind'
import * as React from 'react'

import ga from '../../../common/utils/ga'
import { ISubMenuItem, ITopMenuItem } from '../../../config/sites/menus/types'
import CategoryLink from './categoryLink'

import * as styles from './categoriesMenu.module.css'

const TopLevelMenu = ({ menuItem }: { menuItem: ITopMenuItem }) => {
  const { isInternal, isExternal, isNew, name, rel, target, url } = menuItem
  const cx = classNames.bind(styles)
  const hasChildren = menuItem.children.length > 0
  const desktopOnlyChildren = menuItem.children.filter(
    menuItemChild => !menuItemChild.isMobile
  )
  const linkClassName = cx(styles.link, {
    link: hasChildren,
    linkEmpty: !hasChildren,
    linkExternal: isExternal
  })

  const sendGAEvent = () => {
    ga('send', {
      hitType: 'event',
      eventCategory: 'MarketNav',
      eventAction: 'click',
      eventLabel: name
    })
  }

  return (
    <li className={styles.menuItem} aria-haspopup="true">
      <CategoryLink
        onClick={sendGAEvent}
        to={url}
        isInternal={isInternal}
        className={linkClassName}
        target={target}
        rel={rel}
      >
        {name + ' '}
        {isNew && <span className={styles.label}>New</span>}
      </CategoryLink>
      {hasChildren && (
        <SubLevelMenu
          onItemClick={sendGAEvent}
          menuItems={desktopOnlyChildren}
        />
      )}
    </li>
  )
}

const SubLevelMenu = ({
  menuItems,
  onItemClick
}: {
  menuItems: ISubMenuItem[]
  onItemClick: () => any
}) => {
  const cx = classNames.bind(styles)

  return (
    <div className={styles.dropdownContainer}>
      <ul className={styles.dropdown}>
        {menuItems.map((menuItem, key) => {
          const { isBottom, isInternal, isTop, name, url } = menuItem
          const linkClassName = cx(
            { dropdownTop: isTop },
            { dropdownBottom: isBottom }
          )

          return (
            <li className={linkClassName} key={key}>
              <CategoryLink
                onClick={onItemClick}
                to={url}
                isInternal={isInternal}
              >
                {name + ' '}
              </CategoryLink>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

const CategoriesMenu = ({ menuConfig }: { menuConfig: ITopMenuItem[] }) => {
  return (
    <ul className={styles.linksList} data-test-selector="category-menu">
      {menuConfig.map((menuItem, key) => {
        return <TopLevelMenu key={key} menuItem={menuItem} />
      })}
    </ul>
  )
}

export default CategoriesMenu
